import React from 'react'
import RegisterGoogleDetail from '../../../common/GoogleOriginalDesign/Hotelslabo/Detail/RegisterGoogleDetail'

export default function GenieeLineRegister() {
    return (
        <RegisterGoogleDetail
            reasonPoint1Images={[
                {
                    src: '/pages/geniee/hotelslabo/reason_point1_img1.png',
                    alt: 'GENIEE離脱POPの限定求人詳細1枚目',
                },
                {
                    src: '/pages/geniee/hotelslabo/reason_point1_img2.png',
                    alt: 'GENIEE離脱POPの限定求人詳細2枚目',
                },
                {
                    src: '/pages/geniee/hotelslabo/reason_point1_img3.png',
                    alt: 'GENIEE離脱POPの限定求人詳細3枚目',
                },
            ]}
            signupPath='signup?channel=hotel_geniee_line'
        />
    )
}
